import React from "react"

import { useTranslation } from "@bounce/i18n"

import { PlaceList } from "@/components/Generic/PlaceList/PlaceList"
import type { TopCity } from "@/libs/bounce/cities"
import type { FormattedBlogPost } from "@/libs/prismic/types"
import { cityToLink } from "@/utils/city"

export type CityListProps = {
  article: FormattedBlogPost
  topCities: TopCity[]
}

export const CityList = ({ topCities, article }: CityListProps) => {
  const { t } = useTranslation("marketing-generic")
  const isGuide = ["guide", "visitor_guide", "layover_guide"].includes(article.type)
  const links = topCities.map(topCity => cityToLink(topCity))

  if (!isGuide) return null

  return (
    <PlaceList
      title={t("page.article.exploreTheWorld", "Explore the world")}
      links={links}
      className="w-full mt-section"
    />
  )
}
